import Alpine from 'alpinejs'
import LeStickyHeader from '../libs/stickyheader/le-sticky_header.js'
import LeAdminbar from "../libs/adminbar/le-adminbar.class.js";
import LeAccordion from "../libs/accordion/le-accordion.class.js";
import i96Toolbox from "./includes/i96Toolbox.class.js";
import LeStickyIt from "../libs/stickit/le-stick_it.js";
import knInitSwiper from "./includes/swiper.inc.js";
import lightbox from "./includes/photoswipe.inc.js";
import LeA11y from "../libs/a11y/le-a11y.class.js";
import I96Parallax from "../libs/parallax/i96-parallax.class.js";
import LeReadMore from "../libs/readmore/le-readmore.class.js";
import StagerNewsletter from "./includes/stager-newsletter.js";

// NEWSLETTER
// -------------------------
const newsletter = new StagerNewsletter('.knust-f-newsletter');

window.i96t = new i96Toolbox();
knInitSwiper();

document.addEventListener("DOMContentLoaded", function(){

    // Handler when the DOM is fully loaded
    console.log('breathing the clouds');

    window.Alpine = Alpine
    Alpine.start()

    const sticky_header  = new LeStickyHeader({
        // threshold: 400,
        // debug: true,
        // selector_header: '#masthead'
    });

    const admin_bar = new LeAdminbar( {debug: false});

    // ACCORDION
    window.akk = new LeAccordion({
        // debug: true
    });
    window.akk.init();
    setTimeout( () => {
        window.akk.reset();
    }, 250);

    // if (document.querySelector('.event-template-default')) {
    //     const stick_tickets = new LeStickyIt( {
    //         debug: false
    //     });
    // }
    //
    if (document.querySelector('.page-template-programm-tpl')) {
        const stick_programm = new LeStickyIt( {
            selector_container: '.kn-section-programm',
            selector_content: '.page-template-programm-tpl .le-left .kn-box > .kn-box-claim',
            sticky_margin: 0,
            sticky_detection_margin: 0,
            debug: false
        });

        // const stick_filter2 = new LeStickyIt( {
        //     selector_container: '.le-right',
        //     selector_content: '.page-template-programm-tpl #kn-programm-filter',
        //     debug: false
        // });
    }

    // if (document.querySelector('.page-template-historie-tpl')) {
    //     const stick_historie = new LeStickyIt( {
    //         selector_container: '.kn-section-historie',
    //         selector_content: '.page-template-historie-tpl .le-left .kn-box > .kn-box-claim',
    //         sticky_margin: 0,
    //         sticky_detection_margin: 0,
    //         debug: false
    //     });
    //
    //     // const stick_filter2 = new LeStickyIt( {
    //     //     selector_container: '.le-right',
    //     //     selector_content: '.page-template-programm-tpl #kn-programm-filter',
    //     //     debug: false
    //     // });
    // }


    // -----------------------------------------
    // READ MORE
    // -----------------------------------------
    const kn_readmore = new LeReadMore( {
        debug: true
    } );
    kn_readmore.init();

    // -----------------------------------------
    // A11Y
    // -----------------------------------------

    const kn_a11y = new LeA11y({
        button_selector_base: '.kn-a11y-item',
        minFontSize: 0,
        maxFontSize: 3,
        // debug: true,
        onSizeChangeCallback: () => {
            if (window.akk) {
                window.akk.reset();
            }
        }
    });
    kn_a11y.init();

    // -----------------------------------------

    const parallax = new I96Parallax({
        debug: false
    });


    // WP ACCORDION: SMOOTH OPEN/CLOSE
    // -------------------------------------
    document.querySelectorAll('.wp-block-accordion-item').forEach(function(accordion_item) {

        const header_height = accordion_item.querySelector('.wp-block-accordion-heading').offsetHeight;
        const iz_open = accordion_item.classList.contains('is-open');
        if (!iz_open) {
            accordion_item.style.maxHeight = header_height + 'px';
        } else {
            const panel_ele = accordion_item.querySelector('.wp-block-accordion-panel');
            const panel_height = panel_ele.offsetHeight;
            accordion_item.style.maxHeight = (header_height + panel_height) + 'px';
        }

        accordion_item.querySelector('.wp-block-accordion-heading__toggle').addEventListener('click', function( ev ) {

            const this_accordion_item = ev.target.closest('.wp-block-accordion-item');
            const item_height = this_accordion_item.offsetHeight;
            const is_collapsed= item_height < 90;

            setTimeout( () => {

                const panel_ele = this_accordion_item.querySelector('.wp-block-accordion-panel');
                const panel_height = panel_ele.offsetHeight;

                if ( is_collapsed ) {
                    this_accordion_item.style.maxHeight = (header_height + panel_height) + 'px';
                } else {
                    this_accordion_item.style.maxHeight = header_height + 'px';
                }

            },50);

        });
    })

});

console.log('drinking the rain');
